import { COUPON_STATUS } from "@/constants/coupon";
import { getCounponNum, getUserVips } from "@/services";

export default function vip(set) {
  return {
    unPayOrders: [],
    /**@type {IVip[]} */
    vips: [],
    expiredVips: null,
    couponNum: 0,
    async refreshCouponNum() {
      const result = await getCounponNum({ status: COUPON_STATUS.GOT });

      if (result.err) return;

      set({
        couponNum: +result.count,
      });

      return result.count;
    },
    async refreshVips() {
      const vipResult = await getUserVips();
      set({
        vips: vipResult.filter((vip) => !vip.is_expired),
        // 过期会员
        expiredVips: vipResult.filter((vip) => vip.is_expired),
      });
      return vipResult;
    },
  };
}
